"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FixedBanner;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _intents = _interopRequireWildcard(require("@site/pattern-library-utils/intents"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _icon = require("@site/pattern-library-utils/icon");
var _boxModelSize = require("@site/pattern-library-utils/box-model-size");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _react2 = require("@linaria/react");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _closeButton = _interopRequireDefault(require("@site/pattern-library-core/close-button"));
var _salesFooter = require("../../../navigation/footer/sales-footer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FixedBannerSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "FixedBannerSection",
  class: "pl-fc7zenp",
  vars: {
    "fc7zenp-0": [({
      bannerClosed
    }) => bannerClosed ? 'none' : 'grid'],
    "fc7zenp-3": [({
      gridTemplateAreas
    }) => `'${gridTemplateAreas}'`],
    "fc7zenp-11": [({
      backgroundColor
    }) => backgroundColor?.rgb ?? _intents.default.ux.boxHighContrast.backgroundColor]
  }
});
const IconBase = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconBase",
  class: "pl-ilx05un"
});
const ContentWrapper = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "ContentWrapper",
  class: "pl-c1q1aeuj"
});
const CloseButton = /*#__PURE__*/(0, _react2.styled)(_closeButton.default)({
  name: "CloseButton",
  class: "pl-crjbqtl"
});

/**
 * FixedBanner component.
 * @module FixedBanner
 *
 * @param {Object} props React props
 * @param {string} props.icon icon's name
 * @param {string} props.description description text
 * @param {boolean} props.dismissible if the banner can be closed
 * @param {object} props.backgroundColor Color of the tile(rbg property)
 * @param {boolean} props.invert Invert colorscheme of section
 * @param {string} props.verticalMargin Vertical Spacing value
 * @param {string} props.partial Partial
 * @returns {React.ReactElement} FixedBanner component
 * @public
 */
function FixedBanner({
  icon,
  description,
  dismissible,
  backgroundColor,
  invert,
  verticalMargin = 'none',
  partial
}) {
  const [bannerClosed, setBannerClosed] = (0, _react.useState)(false);
  const container = (0, _react.useRef)(null);
  function getGridAreas(hasIcon, isDimissible) {
    let result = 'content content content';
    if (hasIcon && isDimissible) {
      result = 'icon content close';
    } else if (isDimissible) {
      result = 'content content close';
    } else if (hasIcon) {
      result = 'icon content close';
    }
    return result;
  }
  const iconPx = 20;
  const gridTemplateAreas = getGridAreas(icon !== null, dismissible);
  return /*#__PURE__*/_react.default.createElement(FixedBannerSection, {
    padding: "large",
    textAlign: "start",
    verticalMargin: verticalMargin,
    gridTemplateAreas: gridTemplateAreas,
    bannerClosed: bannerClosed,
    backgroundColor: (0, _intents.getBackgroundColor)(backgroundColor),
    dataCy: "fixed-banner",
    className: "legacy-container",
    partial: partial || (invert ? 'dark1' : '')
  }, icon && /*#__PURE__*/_react.default.createElement(IconBase, {
    "data-cy": "icon"
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: icon,
    height: iconPx,
    width: iconPx
  })), /*#__PURE__*/_react.default.createElement(ContentWrapper, {
    "data-cy": "content"
  }, description), dismissible && /*#__PURE__*/_react.default.createElement(CloseButton, {
    className: "ux-button ux-button-stateless ux-button-square modal-close",
    "data-partial": partial || (invert ? 'dark1' : ''),
    "data-cy": "close",
    ref: container,
    onClose: () => setBannerClosed(true)
  }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "x",
    height: iconPx,
    width: iconPx
  })));
}
FixedBanner.propTypes = {
  icon: _propTypes.default.string,
  description: _propTypes.default.string,
  dismissible: _propTypes.default.bool,
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]),
  invert: _propTypes.default.bool,
  verticalMargin: _propTypes.default.string,
  partial: _propTypes.default.string,
  ..._boxModelSize.marginProps
};